import Box from "ds/components/Box";
import Typography from "ds/components/Typography";

import styles from "./styles.module.css";
import { ReactComponent as EmptyPlaceholder } from "./empty-placeholder.svg";

const MainNavigationPinnedItemsEmptyState = () => {
  return (
    <Box
      className={styles.emptyState}
      direction="column"
      align="center"
      justify="center"
      gap="medium"
      padding="x-large small"
    >
      <EmptyPlaceholder />

      <Typography variant="p-body3" tag="p" align="center">
        Quickly access your most important links by pinning them.
      </Typography>
    </Box>
  );
};

export default MainNavigationPinnedItemsEmptyState;
